import { ICustomError } from '@/bundles/Http/interfaces/ICustomError';

export const REQUEST_CANCELLED_MESSAGE = 'Request cancelled';

/**
 * Both request pipelines reject an aborted request with this message: the v2 services as an
 * ErrorMapper object, the legacy ServiceFactory services as a plain Error with no status.
 * The notifications store never shows it, so callers only need this for control flow, e.g.
 * leaving `loading` on while the newer request that replaced this one is still running.
 */
export const isRequestCancelledError = (error: any): boolean => error?.message === REQUEST_CANCELLED_MESSAGE;

export default class ErrorMapper {
  /**
   * The v1 API answers `ctx.throw(status, message)` with the bare text, the v2 API with
   * `{ message }` or `{ error }`, and a v2 validation failure can send an array of messages.
   * Falls back to axios's own `error.message` when the body carries nothing usable.
   */
  getErrorMessage (error: any): Error {
    const data = error?.response?.data;
    let message = error.message;

    if (typeof data === 'string' && data.trim()) {
      message = data;
    } else if (data && typeof data === 'object') {
      if (Array.isArray(data.message)) {
        message = data.message.filter(Boolean).join('. ') || message;
      } else {
        message = data.message || data.error || message;
      }
    }

    return new Error(message);
  }
  mapToCodeModel (error: any): ICustomError {
    const parsedError = {
      message: this.getErrorMessage(error).message,
      title: error?.response?.statusText || 'Error',
      status: error?.response?.status || 400,
      url: error?.request?.responseURL
    };

    throw parsedError;
  }
}
